<div class="section">
    <div class="take-photo-mobile">
        <h4>Take photo</h4>
        <div class="warning-block">
            <div class="warning-block__icon">
                <i class="icon-info"></i>
            </div>
           <div class="warning-block__title">
                <span>There are passport applications that can be helpful in capturing a compliant photo.</span>
           </div>

        </div>

        <p><b>Please, follow the rules for a better result</b></p>
        <ol>
            <li>Jpg format.</li>
            <li>Forward-facing with your entire face, head, shoulders, and eyes completely visible.</li>
            <li>Clear, well-lit photo of only you.</li>
            <li>Plain white or off-white background.</li>
            <li>No sunglasses or hats.</li>
            <li>No black and white photos.</li>
            <li>Maximum size of file is 10 Mb.</li>
            <li>The image should be atleast 800 pixels.</li>
        </ol>
        <div class="info-message">
            If the photo does not meet these rules, it will be declined.
        </div>
        <p><b>Good and bad examples</b></p>

        <div class="imgs-wrapper">
            <div class="img-wrp">
                <img src="/assets/img/employee-badge-request/photo-03.jpg" alt="Good image">
                <i class="icon-tick"></i>
            </div>
            <div class="img-wrp middle">
                <img src="/assets/img/employee-badge-request/photo-02.jpg" alt="Bad image">
                <i class="icon-close"></i>
            </div>
            <div class="img-wrp">
                <img src="/assets/img/employee-badge-request/photo-01.jpg" alt="Bad image">
                <i class="icon-close"></i>
            </div>
            <div class="clearfix"></div>
        </div>
    </div>
    <div class="mobile-camera-block">
        <ui-mobile-camera-and-preview
        [defaultConfig]="cameraConfig"
        [newFileName]="newFileName"
        [dataUrl]="userPhotoUrl"
        [canUseCurrentImage]="canUseCurrentImage"
        [photoData]="photoData"
        (onPhotoTaken)="onPhotoTaken($event)"
        (onDeletePhoto)="deletePhoto()"
        (onUseCurrentPhoto)="useCurrentPhoto()"
        >
        </ui-mobile-camera-and-preview>
    </div>
</div>
